if (!customElements.get('ss-complete-set')) {
  customElements.define('ss-complete-set', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = this.closest('form');
      if (!this.form) return;
      this.controller = new AbortController();
      this.button = this.form.querySelector('[type="submit"] span');
      this.total = this.querySelector('.ss-set-total');
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency', currency: this.dataset.currency,
        minimumFractionDigits: 0, maximumFractionDigits: 2
      });
      this.form.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      this.form.addEventListener('input', () => this.update(), { signal: this.controller.signal });
      const quantityInput = this.form.elements.namedItem('quantity');
      quantityInput?.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      quantityInput?.addEventListener('input', () => this.update(), { signal: this.controller.signal });
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    selected() {
      return [...this.querySelectorAll('[data-ss-holder]:checked:not(:disabled)')];
    }

    update() {
      const selected = this.selected();
      const quantity = Math.max(1, Number(this.form.elements.namedItem('quantity')?.value) || 1);
      const submit = this.form.querySelector('[type="submit"]');
      if (this.button && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') {
        this.button.textContent = selected.length ? this.dataset.addSelected : this.dataset.addDefault;
      }
      const acceleratedCheckout = this.form.querySelector('.shopify-payment-button');
      if (acceleratedCheckout) acceleratedCheckout.hidden = selected.length > 0;
      this.total.hidden = selected.length === 0;
      if (!selected.length) return;
      const diapers = quantity === 1 ? this.dataset.oneDiaper : this.dataset.diapers.replace('[count]', quantity);
      const holders = selected.length === 1 ? this.dataset.oneHolder : this.dataset.holders.replace('[count]', selected.length);
      this.total.querySelector('span').textContent = `${diapers} + ${holders}`;
      const amount = Number(this.dataset.price) * quantity + selected.reduce((sum, box) => sum + Number(box.dataset.price), 0);
      this.total.querySelector('strong').textContent = this.money.format(amount / 100);
    }

    appendItems(formData) {
      const selected = this.selected();
      if (!selected.length) return 0;
      for (const [key, value] of [...formData.entries()]) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          const itemKey = key.startsWith('properties[') ? `[properties]${key.slice(10)}` : `[${key}]`;
          formData.append(`items[0]${itemKey}`, value);
          formData.delete(key);
        }
      }
      if (!formData.has('items[0][quantity]')) formData.set('items[0][quantity]', '1');
      selected.forEach((box, index) => {
        formData.append(`items[${index + 1}][id]`, box.value);
        formData.append(`items[${index + 1}][quantity]`, '1');
      });
      return selected.length;
    }
  });
}
